import React from 'react';
import { FileText, Copyright, Building2, ShoppingBag, Search } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../data/mock';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const iconMap = {
  FileText: FileText,
  Copyright: Copyright,
  Building2: Building2,
  ShoppingBag: ShoppingBag,
  Search: Search
};

const Services = () => {
  const servicesData = [
    { title: 'Trademark Registration', description: 'Protect your brand name, logo, or slogan with fast and reliable trademark registration consultancy.', icon: 'FileText', link: '/trademark-registration' },
    { title: 'Copyright Registration', description: 'Secure your creative works with our expert copyright registration services.', icon: 'Copyright', link: '/copyright-registration' },
    { title: 'Company Formation', description: 'Start your business the right way with professional LLC or Corporation setup.', icon: 'Building2', link: '/company-formation' },
    { title: 'Amazon Brand Registry', description: 'Get verified on Amazon and safeguard your products with ease.', icon: 'ShoppingBag', link: '/amazon-brand-registry' },
    { title: 'Trademark Search', description: 'Avoid conflicts and ensure your trademark is unique with our thorough search services.', icon: 'Search', link: '/trademark-search' }
  ];

  const renderServiceCard = (service, index) => {
    const Icon = iconMap[service.icon];
    return (
      <Link key={index} to={service.link}>
        <Card className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 hover:border-emerald-200 cursor-pointer h-full">
          <CardHeader>
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-100 to-blue-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
              <Icon className="w-8 h-8 text-emerald-600" />
            </div>
            <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-emerald-600 transition-colors">
              {service.title}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <CardDescription className="text-gray-600 leading-relaxed">
              {service.description}
            </CardDescription>
          </CardContent>
        </Card>
      </Link>
    );
  };

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-xl font-semibold">
            Services
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Reliable Solutions for Your Brand's Protection
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We offer a full suite of services to help protect your brand and help your business grow. From trademark registration to company formation, our expert team helps you secure your intellectual property and make sure it is compliant, giving you peace of mind to focus on what matters most — Building Your Brand.
          </p>
        </div>

        {/* Desktop Grid - Hidden on mobile/tablet */}
        <div className="hidden lg:grid grid-cols-3 gap-8">
          {servicesData.map((service, index) => renderServiceCard(service, index))}
        </div>

        {/* Mobile/Tablet Slider - Hidden on desktop */}
        <div className="lg:hidden">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet !bg-emerald-600',
              bulletActiveClass: 'swiper-pagination-bullet-active'
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20
              }
            }}
            className="services-slider"
          >
            {servicesData.map((service, index) => (
              <SwiperSlide key={index}>
                {renderServiceCard(service, index)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Services;